import Loadable from 'react-loadable';

import { LoadingPageLoadable } from 'modules/main/pages/Loading';

export const IntegrateAtsLinksLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "IntegrateAtsLinks" */
      './IntegrateAtsLinks.dynamic'
    ),
  loading: LoadingPageLoadable,
});
